"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.95243 4.24359C9.29111 4.19352 9.64048 4.16666 10.0003 4.16666C14.2545 4.16666 17.046 7.92068 17.9839 9.40566C18.0974 9.5854 18.1541 9.67526 18.1859 9.81387C18.2097 9.91797 18.2097 10.0822 18.1859 10.1863C18.1541 10.3249 18.0969 10.4154 17.9826 10.5963C17.7327 10.9918 17.3518 11.5476 16.847 12.1503M5.60359 5.59585C3.80187 6.81807 2.57871 8.51613 2.01759 9.40438C1.90357 9.58487 1.84656 9.67511 1.81478 9.81371C1.79091 9.91781 1.7909 10.082 1.81476 10.1861C1.84652 10.3247 1.90328 10.4146 2.01678 10.5943C2.95461 12.0793 5.74616 15.8333 10.0003 15.8333C11.7157 15.8333 13.1932 15.223 14.4073 14.3971M2.50034 2.5L17.5003 17.5M8.23256 8.23221C7.78015 8.68462 7.50033 9.30962 7.50033 9.99998C7.50033 11.3807 8.61961 12.5 10.0003 12.5C10.6907 12.5 11.3157 12.2201 11.7681 11.7677",
    stroke: fill,
    strokeWidth: "1.66666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports["default"] = _default;